import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import {
  Card,
  CardBody,
  Collapse,
} from 'reactstrap';
import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/table';
import 'tinymce/plugins/media';
import 'tinymce/plugins/code';
import 'tinymce/skins/ui/oxide/skin.min.css';
import { Editor } from '@tinymce/tinymce-react';

import AdminPageSectionHeader from './SectionHeader';
import AdminPageSectionMeta from './SectionMeta';

import ItemTypes from '../../../helpers/DNDItemTypes';
import {
  pageSectionsTarget,
  pageSectionsSource,
} from '../../../helpers/DNDPageSections';

if (typeof window !== 'undefined' && !window.tinymce) {
  window.tinymce = tinymce;
}

class AdminPageSectionHTML extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
    }
  }

  handleChange(value) {
    const {
      section,
      handleChangeSection,
    } = this.props;

    section.content = value;
    handleChangeSection(section);
  }

  render() {
    const {
      id,
      section,
      sectionIndex,
      sectionsCount,
      isClosed,
      isDragging,
      handleChangeSection,
      handleDeleteSection,
      handleSwitchSection,
      handleMoveSectionByIndex,
      connectDragSource,
      connectDropTarget,
    } = this.props;

    return (
      connectDragSource(connectDropTarget((
        <div id={`s-${id}`} className={classnames('section-container', `section-${section.section}`, { dragging: isDragging })}>
          <Card>
            <AdminPageSectionHeader
              section={section}
              sectionIndex={sectionIndex}
              sectionsCount={sectionsCount}
              isClosed={isClosed}
              handleDeleteSection={handleDeleteSection}
              handleSwitchSection={handleSwitchSection}
              handleMoveSection={handleMoveSectionByIndex}
            />
            <Collapse isOpen={!isClosed}>
              <CardBody>
                <AdminPageSectionMeta
                  section={section}
                  handleChangeSection={handleChangeSection}
                />
                {!isDragging ? (
                  <Editor
                    value={section.content}
                    init={{
                      height: 500,
                      menubar: false,
                      skin: false,
                      content_css: false,
                      body_class: 'tmcee',
                      relative_urls: false,
                      remove_script_host: false,
                      content_style: '.tmcee { font-family: \'Source Sans Pro\', sans-serif; } .tmcee h1, .tmcee h2, .tmcee h3, .tmcee h4, .tmcee h5, .tmcee h6 { font-weight: 500; } .tmcee iframe, .tmcee .mce-object-iframe { width: 100%; height: 100%; }',
                      plugins: [
                        'lists',
                        'link',
                        'preview',
                        'table',
                        'media',
                        'code',
                      ],
                      toolbar:
                        'undo redo | blocks | bold italic forecolor |' +
                        'alignleft aligncenter alignright alignjustify link |' +
                        'bullist numlist outdent indent | table | media code',
                    }}
                    onEditorChange={this.handleChange}
                  />
                ) : (
                  <div style={{ height: 500 }} />
                )}
              </CardBody>
            </Collapse>
          </Card>
        </div>
      )))
    );
  }
}

AdminPageSectionHTML.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  sectionsCount: PropTypes.number.isRequired,
  isClosed: PropTypes.bool.isRequired,
  handleChangeSection: PropTypes.func.isRequired,
  handleDeleteSection: PropTypes.func.isRequired,
  handleSwitchSection: PropTypes.func.isRequired,
  handleMoveSectionByIndex: PropTypes.func.isRequired,
};

export default
DragSource(ItemTypes.PAGE_SECTION, pageSectionsSource, (DNDconnect, monitor) => ({
  connectDragSource: DNDconnect.dragSource(),
  connectDragPreview: DNDconnect.dragPreview(),
  isDragging: monitor.isDragging(),
}))(DropTarget(ItemTypes.PAGE_SECTION, pageSectionsTarget, DNDconnect => ({
  connectDropTarget: DNDconnect.dropTarget(),
}))(connect()(AdminPageSectionHTML)));
